import { EventName, EventDescription, EventIcon } from "./eventDescription";

// Componente reutilizable para renderizar columna de eventos (vista Partido)
export default function EventColumn({ teamEvents, teamInfo, isHome = true }) {
  return (
    <div className={`timeline-column timeline-column--${isHome ? "home" : "away"}`}>
      <div className="timeline-column-header">
        <span className="team-name">{teamInfo.name}</span>
      </div>
      <div className="timeline-events">
        {teamEvents.length > 0 ? (
          teamEvents.map((event, index) => (
            <div key={index} className={`timeline-event timeline-event--${isHome ? "home" : "away"}`}>
              {!isHome && <EventIcon event={event} />}
              <div className="event-content">
                <div className="event-player">{EventName(event)}</div>
                <div className="event-details">{event.timeMin}' - {EventDescription(event)}</div>
              </div>
              {isHome && <EventIcon event={event} />}
            </div>
          ))
        ) : (
          <div className="timeline-empty">
            <p>Sin eventos</p>
          </div>
        )}
      </div>
    </div>
  )
};